export var MY_POSITIONS = "MY_POSITIONS";
export var MY_POSITIONS_STREAM = "MY_POSITIONS_STREAM";
export var MY_POSITIONS_CLEAR_DATA = "MY_POSITIONS_CLEAR_DATA";
export var MY_POSITIONS_ERROR = "MY_POSITIONS_ERROR";
export var MY_POSITIONS_HIDE_ERROR = "MY_POSITIONS_HIDE_ERROR";
export var MY_POSITIONS_START_LOADER = "MY_POSITIONS_START_LOADER";
export var MY_POSITIONS_STOP_LOADER = "MY_POSITIONS_STOP_LOADER";
export var MY_POSITIONS_APPLY_SORT_ = "MY_POSITIONS_APPLY_SORT_";
export var MY_POSITIONS_CLEAR_SORT = "MY_POSITIONS_CLEAR_SORT";
